export const DAYSJOBSSTATUS = 3;